import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const getContract = (state) => {
  return axios.get(API + "contracts/contract-edit/"+state+"/",{headers: authHeader(),});
};
const editContract = (state,contract_number,contract_term,start_date,end_date,paymentstartdate,address_id,contract_type,loanamount,
    iir,
    interestcalculationmethod,
    repaymentprocedure,
    timecountingmethod,
    paymentmethod,
    deposit_amount,
    feesontime,
    tax_rate_rent,
    tax_rate_fee,
  customer_id,
  attribute,
  paymentfrequency,
  paymentrule,
  achPayments,
  achAccount,
  appOriginator,
  source,
  salesRep,
  subcompany,
  line_of_business,
  interest_only_payments,
  contractTerms,
  interest_rate_type,
  base_rate,
  margin,
  description,
  principal_basis,
  credit_line,
  credit_type,
  draw_start_date,
  draw_end_date,
  interest_pay_frequency,
  principal_pay_frequency,
  loan_principal
  ) => {
    return axios.post(API + "contracts/contract-edit/" +state+"/", {
        contract_number,
        contract_term,
        start_date,
        end_date,
        paymentstartdate,
        address_id,
        contract_type,
        loanamount,
        iir,
        interestcalculationmethod,
        repaymentprocedure,
        timecountingmethod,
        paymentmethod,
        deposit_amount,
        feesontime,
        tax_rate_rent,
        tax_rate_fee,
        customer_id,
        attribute,
        paymentfrequency,
        paymentrule,
        enable_ach: achPayments ? "Y" : "N",
        ach_account_id: achAccount || null,
        appOriginator,
        source,
        salesRep,
        subcompany,
        line_of_business,
        interest_only_payments,
        termsCondition: contractTerms,
        interest_rate_type: interest_rate_type,
        base_rate: interest_rate_type === "Floating" ? base_rate : 0,
        margin: interest_rate_type === "Floating" ? margin : 0,
        description:description,
        principal_basis,
        credit_line,
        credit_type,
        draw_start_date,
        draw_end_date,
        interest_pay_frequency,
        principal_pay_frequency,
        loan_principal
    },{headers: authHeader(),});
  };
const EditContractLineOfCreditService = {
    getContract,
    editContract,
  };
  export default EditContractLineOfCreditService;